import { styled } from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';

export const Wrapper = styled.div`
  display: flex;
  gap: ${formatViewport(10)};
  justify-content: center;
  margin-top: ${formatViewport(10)};
  flex-grow: 0;
  flex-shrink: 0;
`;

export const Indicator = styled.div<{ isActive: boolean }>`
  background-color: ${({ isActive }) => (isActive ? 'black' : 'lightgray')};
  border-radius: 50%;
  height: ${formatViewport(12)};
  margin: 0;
  transition: background-color 0.3s ease;
  width: ${formatViewport(12)};
`;
